import classNames from "classnames";
import { RichText } from "components/RichTextWidget";
import { useTranslation } from "features/translations";
import { Heading5, Icon, PageLink, Paragraph } from "shared/components";

import styles from "./Items.module.scss";

const AMOUNT_ITEMS = {
  default: "three",
  3: "three",
  4: "four",
  5: "five",
};

export const Items = ({ items }) => {
  const { t } = useTranslation();
  const itemsAmount = AMOUNT_ITEMS[items.length] || AMOUNT_ITEMS.default;

  return (
    <div className={classNames(styles.items, styles[itemsAmount])}>
      {items.map((item) => (
        <PageLink
          link={item.link}
          key={item.id}
          target={item.target}
          className={styles.link}
        >
          <div className={styles.item}>
            <div className={styles.text}>
              <Heading5 className={styles.title} color="dark">
                {item.title}
              </Heading5>
              <RichText
                className={styles.description}
                value={item.description}
              />
            </div>
            <div className={styles.button}>
              <span className={styles.arrow}>
                <Icon className={styles.icon} name="arrow_right" />
              </span>

              {item.online && (
                <Paragraph
                  color="light"
                  className={styles.online}
                  appearance="bigger"
                >
                  {t("online")}
                </Paragraph>
              )}
            </div>
          </div>
        </PageLink>
      ))}
    </div>
  );
};
